<template>
    <page>
        <module title="会员权益详情">
            <div v-if="activityInfo">
                <c-detail title="基础信息">
                    <c-detail-item label="会员等级名称" full>{{activityInfo.level_name}}</c-detail-item>

                    <c-detail-item label="等级描述" full>{{activityInfo.remark}}</c-detail-item>

                    <c-detail-item label="礼包详情" full>
                        <c-table v-model="giftPackageList" height="auto" border>

                            <c-table-column
                                    label="礼包名称"
                                    name="name"
                                    width="200"
                            >
                            </c-table-column>

                            <c-table-column
                                    label="礼包售价"
                                    name="package_price"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{data.package_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="礼包价值"
                                    name="total_price"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{data.total_price}}</template>
                            </c-table-column>

                        </c-table>
                    </c-detail-item>

                    <c-detail-item label="推荐详情" full>
                        <c-table v-model="awardList" height="auto" border>
                            <c-table-column
                                    label="会员等级"
                                    name="userlevelname"
                                    width="200"
                            >
                                <template v-slot="{data}">
                                    {{'推荐一名  ['+data.userlevelname+']'}}
                                </template>
                            </c-table-column>

                            <c-table-column
                                    label="直推奖励"
                                    name="directly"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{data.directly_reward}}</template>
                            </c-table-column>
                            <c-table-column
                                    label="间推奖励"
                                    name="indirect"
                                    width="80"
                            >
                                <template v-slot="{data}">￥{{data.indirect_reward}}</template>
                            </c-table-column>
                        </c-table>
                    </c-detail-item>
                    <c-detail-item label="团队推荐奖励" full>{{activityInfo.team_reward_ratio}}%</c-detail-item>
                    <c-detail-item label="推荐奖励说明" full>{{activityInfo.reward_remark}}</c-detail-item>
                    <c-detail-item label="团队奖励说明" full>{{activityInfo.team_reward_remark}}</c-detail-item>
                    <c-detail-item label="等级折扣价" full>{{activityInfo.discount}}%</c-detail-item>
                    <c-detail-item label="等级折扣说明" full>{{activityInfo.discount_remark}}</c-detail-item>
                    <c-detail-item label="差价返佣说明" full>{{activityInfo.brokerage_remark}}</c-detail-item>
                </c-detail>
            </div>
        </module>
    </page>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: 'user_level_detail',

        props: {
            id: String
        },

        data() {
            return {
                activityInfo: '',
                giftPackageList: [],
                awardList: []
            }
        },

        computed: {
            ...mapState(['dict'])
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/user_level/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.activityInfo = data;
                        this.awardList = data.awardList;
                        this.giftPackageList = data.giftPackageDetailMapList;
                    }
                });
            }
        }
    }
</script>